// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

// GENERATED FILE. DO NOT EDIT MANUALLY.

module.exports = '1.5.1-beta.1';
